import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { OptionFormGroup } from '@/App/tiles/Option/fields/OptionFormGroup.tsx';
import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useCheckOption } from '@/App/tiles/Option/QueueContext.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { selectOptionLegsValidation } from '@/store/option/selectors/optionSelectors.ts';
import type { LegId, OptionBarrier } from '@/store/option/state.ts';

type TriggerStartDateProps = {
  tileId: string;
  barrier: OptionBarrier;
  numberOfBarrier?: number;
};

export function TriggerStartDate({ tileId, barrier, numberOfBarrier = 1 }: TriggerStartDateProps) {
  const [checkOption] = useCheckOption();
  const legId: LegId = `${tileId}/0`;

  const { barrierValidation } = useOptionSelector((option) => {
    const validation = selectOptionLegsValidation(option, legId);
    const barrier = numberOfBarrier === 1 ? validation?.barrier1 : validation?.barrier2;
    return { barrierValidation: barrier?.startDate };
  });

  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleBarrierStartDateSelected = (dateOrTenor: string) => {
    sgwtWebAnalytics?.trackEvent('Option', 'Trigger start date selected', dateOrTenor);

    checkOption({
      tileId,
      legProperties: {
        legId,
        [`barrier${numberOfBarrier}`]: {
          startDate: dateOrTenor,
        },
      },
    });
  };

  return (
    <OptionFormGroup label={<FormattedMessage id="option.fields.triggerStartDate" />}>
      <TradeCaptureValidationWrapper validation={barrierValidation}>
        <DatePickerWithTenorNext
          data-e2e={`trigger-${numberOfBarrier}-start-date`}
          date={barrier.startDate}
          onChange={handleBarrierStartDateSelected}
        />
      </TradeCaptureValidationWrapper>
    </OptionFormGroup>
  );
}
